<template>
  <div class="user-info">
    <div class="user-info-header">
      <div class="icon-title">
        <img
          :src="require('@/assets/images/userPage/user.png')"
          alt="个人信息"
          class="icon"
        />
        个人信息
      </div>
      <div>
        <button class="tool-button" @click="handleChangeUserInfo">
          修改信息
        </button>
        <button class="tool-button" @click="handleChangePassword">
          修改密码
        </button>
      </div>
    </div>
    <div class="user-info-content">
      <div
        class="user-info-content-line"
        v-for="item in userInfo"
        :key="item.title"
      >
        <img :src="item.icon" :alt="item.title" class="info-icon" />
        <span class="info-lable">{{ item.title }}</span
        ><b>：</b><span class="note-content">{{ item.content }}</span>
      </div>
      <div class="user-info-content-line">
        <img :src="note.icon" :alt="note.title" class="info-icon" />
        <span class="info-lable">备注</span><b>：</b
        ><span class="note-content">{{ note.content }}</span>
      </div>
    </div>
    <div class="user-info-header">
      <div class="icon-title">
        <img
          :src="require('@/assets/images/userPage/list.png')"
          alt="浏览记录"
          class="icon"
        />
        浏览记录
      </div>
    </div>
    <book-carousel-content
      :carouselData="this.carouselData"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
    ></book-carousel-content>
    <div>
    <my-dialog
      :title="'修改个人信息'"
      data-warden-title="用户信息"
      :confirmButtonText="'保存'"
      ref="changeUserInfo"
      class="changeUserInfo"
    >
      <change-user-info
        ref="userInfoForm"
      ></change-user-info>
    </my-dialog>
    </div>
    <div>
    <my-dialog
      :title="'修改密码'"
      data-warden-title="修改密码"
      :confirmButtonText="'保存'"
      ref="changePassword"
      class="changePassword"
    >
      <change-password ref="passForm"></change-password>
    </my-dialog>
    </div>
  </div>
</template>

<script>
import BookCarousel from '../../components/BookCarousel.vue'
import ChangeUserInfo from '../../components/ChangeUserInfo.vue'
import ChangePassword from '../../components/ChangePassword.vue'
import MyDialog from '../../components/MyDialog.vue'
import BookCarouselContent from '../../components/BookCarouselContent.vue'
import CryptoJS from 'crypto-js'
import { Message } from 'element-ui'
export default {
  components: {
    BookCarousel,
    ChangeUserInfo,
    MyDialog,
    ChangePassword,
    BookCarouselContent
  },
  name: 'UserInfo',
  data () {
    return {
      userId: 3,
      userInfo: [
        {
          title: '用户名',
          content: '',
          icon: require('@/assets/images/userPage/user.png')
        },
        {
          title: '手机号',
          content: '',
          icon: require('@/assets/images/userPage/phone.png')
        },
        {
          title: '邮箱',
          content: '',
          icon: require('@/assets/images/userPage/location.png')
        },
        {
          title: '联系地址',
          content: '',
          icon: require('@/assets/images/userPage/address.png')
        }
      ],
      note: {
        title: '备注',
        content: '',
        icon: require('@/assets/images/userPage/chat.png')
      },
      carouselData: [],
      user: [],
      loading: true
    }
  },
  created () {
    let isLogined = localStorage.getItem('isLogined')
    this.getInfo(isLogined)
    this.getViewHistory(isLogined)
  },
  // mounted () {
  //   var that = this
  //   window['test'] = (event, msg) => {
  //     that.getInfo(msg)
  //   }
  // },
  methods: {
    getInfo (msg) {
      if (String(msg) === 'true') {
        this.userId = localStorage.getItem('userId')
        let url = 'retrieve/user/getPersonalIfo?userId=' + this.userId
        // let params = new URLSearchParams()
        this.$http
          .get(url)
          .then(res => {
            // console.log(res.data.data)
            this.user = res.data.data
            this.userInfo[0].content = res.data.data.username
            this.userInfo[1].content = res.data.data.phone
            this.userInfo[2].content = res.data.data.email
            this.userInfo[3].content = res.data.data.address
            for (let i in this.userInfo) {
              if (this.userInfo[i].content === null) {
                this.userInfo[i].content = ''
              }
            }
            this.note.content = ''
            // console.log(this.userInfo)
            //处理备注换行问题
            let arr = res.data.data.note.split(/[\n]/)
            for (let i =0 ; i < arr.length - 1 ; i++) {
              let tmp =arr[i] + '\n\t'
              this.note.content = this.note.content + tmp
            }
            this.note.content = this.note.content + arr[arr.length - 1]
          })
          .catch(err => {
            console.log('获取个人信息失败', err)
          })
      } else {
        // this.userInfo[0].content = 'admin'
        // this.userInfo[1].content = '123456789'
        // this.userInfo[3].content = '这是联系地址'
      }
    },
    handleChangeUserInfo () {
      this.$refs.changeUserInfo.open(() => {
        console.log(this.$refs.userInfoForm.flag)
        if (this.$refs.userInfoForm.flag) {
          let url = 'retrieve/user/updateUser'
          let params = new URLSearchParams()
          params.append('userName', this.$refs.userInfoForm.userInfo.username.content)
          params.append('trueName', this.user.truename)
          params.append('sex', this.user.sex)
          params.append('phone', this.$refs.userInfoForm.userInfo.phone.content)
          params.append('address', this.$refs.userInfoForm.userInfo.address.content)
          params.append('email', this.$refs.userInfoForm.userInfo.mail.content)
          params.append('note', this.$refs.userInfoForm.note.content)
          params.append('userId', String(this.userId))
          this.$http.post(url, params).then(
            res => {
              this.getInfo('true')
            }
          //   err => {
          //     // console.log('修改失败', err)
          //     this.getInfo('true')
          //   }
          )
          Message({
            type: 'success',
            message: '修改个人信息成功!'
          })
          this.getInfo('true')
        } else {
          Message({
            type: 'error',
            message: '输入格式有误!'
          })
        }
      })
    },
    handleChangePassword () {
      this.$refs.changePassword.open(() => {
        if (this.$refs.passForm.flag) {
          let url = 'retrieve/user/changePasswordByUserId'
          let oldPassword = this.$refs.passForm.form.oldPassword.text
          let newPassword = this.$refs.passForm.form.newPassword.text
          // console.log('修改密码', oldPassword, newPassword)
          oldPassword = CryptoJS.MD5(oldPassword).toString()
          newPassword = CryptoJS.MD5(newPassword).toString()
          let params = new URLSearchParams()
          params.append('userId', this.userId)
          params.append('oldPassword', oldPassword)
          params.append('newPassword', newPassword)
          this.$http.post(url, params).then(
            res => {
              console.log('修改密码成功')
              Message({
                type: 'success',
                message: '密码修改成功!'
              })
              this.$parent.$parent.reLogin()
              this.$router.push('/home')
            })
        } else {
          Message({
            type: 'error',
            message: '请检查输入!'
          })
        }
      })
    },
    getViewHistory (msg) {
      if (String(msg) === 'true') {
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/bookLog/getAllBookLog?pageNum=1&pageSize=20&userId=' + userId
        this.$http
          .post(url)
          .then(res => {
            this.loading = false
            // console.log(res)
            let tmp = res.data.data.bookLogList
            for (let i in tmp) {
              let item = tmp[i]
              let bookname = item.bookName
              if (bookname.length > 7) {
                bookname = bookname.slice(0,7) + '...'
              }
              tmp[i] = {
                id: i,
                viewid: item.id,
                bookId: item.bookId,
                name: bookname,
                image: require('@/assets/images/bookCover/u553.jpg')
              }
              let url = '/retrieve/page/getImage'
              let params = {
                bookId: item.bookId,
                page: 1
              }
              this.$http({
                method: 'get',
                url: url,
                params: params,
                responseType: 'blob'
              }).then(res => {
                const binaryData = []
                binaryData.push(res.data)
                const url = window.URL.createObjectURL(
                  new Blob(binaryData, { type: 'image/jpg' })
                )
                tmp[i].image = url
              })
            }
            this.carouselData = tmp
          })
          .catch(err => {
            console.log('获取浏览记录失败', err)
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
.user-info {
  padding: 0 20px;
  padding-top: 10px;
}

.user-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.tool-button {
  width: 130px;
  height: 35px;
  background-color: transparent;
  color: #634c37;
  border: 1px solid #9e5c1d;
  margin-right: 10px;
  font-weight: bold;
  cursor: pointer;
}

.user-info-content {
  margin-left: 55px;
  margin-top: 40px;
  margin-bottom: 180px;
}

.info-icon {
  width: 18px;
  margin-right: 7px;
}

.user-info-content-line {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-bottom: 30px;
  font-size: 16px;
}

.info-lable {
  width: 64px;
  font-weight: bold;
  text-align: justify;
  text-align-last: justify;
}

.info-content {
  margin-left: 28px;
}
.note-content {
  margin-left: 10px;
  text-indent: 30px; 
  width: 530px;
  text-align: left;
  white-space: pre-wrap;
}

.user-info >>> .changeUserInfo .el-dialog {
  width: 700px;
  margin-top: 25vh !important;
}

.user-info >>> .changePassword .el-dialog {
  width: 384px;
  margin-top: 30vh !important;
}

.book-carousel >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.book-carousel >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserInfo.vue